import React, { useState, useEffect } from 'react';
import alanBtn from '@alan-ai/alan-sdk-web'
import { NewsCards} from './components';
import useStyles from './styles.js'
import logo from './images/logo.png';
import wordsToNumbers from 'words-to-numbers';
import { Typography } from '@material-ui/core';
const alanKey = 'f4eb225fba5796ae9e8b4cf402b93c622e956eca572e1d8b807a3e2338fdd0dc/stage'

const App = () => {
    const classes = useStyles();
    const [ newsArticles, setNewsArticles] = useState([])
    const [activeArticle, setActiveArticle] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        alanBtn({
            key: alanKey,
            onCommand: ({ command, articles, number }) => {
                if (command === 'newHeadlines') {
                  setNewsArticles(articles);
                  setActiveArticle(-1);
                } else if (command === 'instructions') {
                  setIsOpen(true);
                } else if (command === 'highlight') {
                  setActiveArticle((prevActiveArticle) => prevActiveArticle + 1);
                } else if (command === 'open') {
                  const parsedNumber = number.length > 2 ? wordsToNumbers((number), { fuzzy: true }) : number;
                  const article = articles[parsedNumber - 1];
        
                  if (parsedNumber > articles.length) {
                    alanBtn().playText('Please try that again...');
                  } else if (article) {
                    window.open(article.url, '_blank');
                    alanBtn().playText('Opening...');
                  } else {
                    alanBtn().playText('Please try that again...');
                  }
                }
              },
            });
          }, []);
        
          return (
            <div>
              <div className={classes.logoContainer}>
                {newsArticles.length ? (
                  <div className={classes.infoContainer}>
                    <div className={classes.card}><Typography variant="h5" component="h2">Try saying:  &quot;Give me the latest <strong><em>Business</em></strong> news&quot; <br /><br />Open article number [4]</Typography></div>
                    <div className={classes.card}><Typography variant="h5" component="h2">Try saying: <br /><br />Go back</Typography></div>
                  </div>
                ) : null}
                <img src={logo} className={classes.image} alt="logo" />
              </div>
              <NewsCards articles={newsArticles} activeArticle={activeArticle} />
              {/* <Modal isOpen={isOpen} setIsOpen={setIsOpen} /> */}
              {!newsArticles.length ? (
                <div className={classes.footer}>
                 <img className={classes.image} src={logo} height="20px" width="60px" alt="JSMastery logo" />
                 
                  
                  <Typography variant="body1" component="h2">
                    Created by
                    <a className={classes.link} href="https://www.linkedin.com/in/Nico-Bazzoni"> Nico Bazzoni </a> -
                    Inspired by
                    <a className={classes.link} href="http://youtube.com/javascriptmastery"> JavaScript Mastery</a>
                  </Typography>
                </div>
              ) : null}
            </div>
          );
        };
        
        export default App;